/**
 * "File as issue" from a Failures row hands the failure to Ask (TRO-488):
 * Ask's issues skill checks for a similar issue and attaches to it, or reads
 * the traces, finds the root cause and files one — the same way it files from
 * an eval or an alert. The occurrences go in as the evidence to use.
 */

import { periodText } from 'features/agent-analytics/components/failures/failuresApi';

const MAX_OCCURRENCES = 20;

/** `period`: the tab's { preset, from, to }, or a window name. */
export function fileIssuePrompt({ cluster, items = [], period = '7d' }) {
  const isRun = cluster.kind === 'run';
  const where = [
    `Agent: ${cluster.agent_name || 'unknown'}`,
    isRun ? null : `Tool: ${cluster.tool || cluster.name || 'unknown'}`,
    `Category: ${cluster.error_class_label}`,
    cluster.error_type ? `Error type: ${cluster.error_type}` : null,
    cluster.status_code ? `Status: ${cluster.status_code}` : null,
  ].filter(Boolean).join(' · ');
  const seen = `${Number(cluster.count || items.length).toLocaleString('en-US')} failure(s) ${periodText(period)}`
    + (cluster.users ? `, ${Number(cluster.users).toLocaleString('en-US')} user(s)` : '');
  const occurrences = items.slice(0, MAX_OCCURRENCES).map((i) => (i.span_id
    ? `- span ${i.span_id} (run ${i.run_id})`
    : `- run ${i.run_id}`));
  return [
    `File an issue for this failure from the Failures tab.`,
    '',
    where,
    cluster.message ? `Message: "${cluster.message}"` : null,
    seen,
    '',
    `Occurrences, newest first${items.length > MAX_OCCURRENCES ? ` (${MAX_OCCURRENCES} of ${items.length})` : ''}:`,
    ...occurrences,
    '',
    'Check for a similar open issue first and attach these as evidence if one matches. '
      + 'Otherwise read a few of these traces, work out the root cause, and file one issue with them as evidence.',
  ].filter((l) => l !== null).join('\n');
}
